import { yupResolver } from '@hookform/resolvers/yup';
import { Stack } from '@mui/material';
import { FormProvider, useForm } from 'react-hook-form';
import { addTwilioAccount } from 'wisestep-api';
import { ControlledTextInput, WsButton, WsTypoColors, WsTypography } from 'wisestep-base';
import { object, string } from 'yup';

import {
  SmsConfigAction,
  useSmsConfigAccessControl,
} from '../../../hooks/useSmsConfigAccessControl';
import { twilioPayload } from '../helper/payload';

const schema = object().shape({
  accountSID: string().required(),
  authToken: string().required(),
});

export interface IAddTwilioAccountProps {
  getAccounts: () => Promise<void>;
}

const AddTwilioAccount = ({ getAccounts }: IAddTwilioAccountProps) => {
  const defaultValues = {
    accountSID: '',
    authToken: '',
  };

  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues: defaultValues,
  });

  const createTwilioAccount = async (data) => {
    await addTwilioAccount({
      ...twilioPayload,
      serviceAccountId: data.accountSID,
      refreshToken: data.authToken,
    });
    getAccounts();
  };

  const { access, owns } = useSmsConfigAccessControl([SmsConfigAction.MANAGE_SMS_CONFIGURATION]);
  const [manageSmsConfig] = access;

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(createTwilioAccount)}>
        <Stack spacing={4}>
          <WsTypography bold={true}>Twilio Account</WsTypography>
          <WsTypography color={WsTypoColors.TERTIARY}>
            There are no accounts set up for Twilio SMS
          </WsTypography>
          {(owns || manageSmsConfig) && (
            <>
              <div>
                <WsTypography bold={true}>Account SID*</WsTypography>
                <ControlledTextInput sx={{ width: 400 }} name="accountSID" />
              </div>
              <div>
                <WsTypography bold={true}>Auth Token*</WsTypography>
                <ControlledTextInput sx={{ width: 400 }} name="authToken" />
              </div>
              <div>
                <WsButton type="submit">Add Account</WsButton>
              </div>
            </>
          )}
        </Stack>
      </form>
    </FormProvider>
  );
};

export default AddTwilioAccount;
